<div class="page">
    <app-header title="{{ 'verification.pageTitle' | translate }}"> </app-header>
    <ngx-loading [show]="showSpinner"></ngx-loading>
    <div class="page-content">
        <div class="table-top">
            <div class="section-header">{{ "verification.pageTitle" | translate }}</div>
        </div>
        <div class="table-body">
            <file-container #fileContainer>
                <filedescriptor [(fileDescriptorId)]="fileDescriptorId"
                                fieldLabel="{{ 'verification.documentToVerify' | translate }}" fileColumnClass="col-md-12"
                                maxSize="41943040" isEncrypted="false" [showPreview]="true" [showAsRequired]="true">
                </filedescriptor>
            </file-container>

            <table class="table table-striped table-bordered"
                   *ngIf="verifyResponse && verifyResponse.verifyDocumentGrid && verifyResponse.verifyDocumentGrid.length > 0">
                <thead>
                    <tr class="table-names">
                        <th>{{ "documentsGrid.typeOfConstancy" | translate }}</th>
                        <th>{{ "documentsGrid.numberOfConstancy" | translate }}</th>
                        <th>{{ "documentsGrid.numberOfInscription" | translate }}</th>
                        <th>{{ "documentsGrid.documentSignedDate" | translate }}</th>
                        <th>{{ "documentsGrid.signer" | translate }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let apiDocument of verifyResponse.verifyDocumentGrid; let i = index">
                        <th>{{ constancyType[apiDocument.constancyType] }}</th>
                        <th>{{ apiDocument.constancyNumber }}</th>
                        <th>{{ apiDocument.registrationNumber }}</th>
                        <th>{{ apiDocument.signedDate }}</th>
                        <th>{{ apiDocument.signer }}</th>
                        <th style="
                            color: green;
                        "><i class="fa fa-check-circle icon"></i></th>
                    </tr>
            </table>
        </div>
        <div class="table-bottom">
            <div class="row">
                <div class="col-md-12 text-right">
                    <app-button [title]="'verification.verifyDocument' | translate" (buttonClick)="verifyDocument()"
                                icon="fa-plus" [disable]="!isAbleToVerify()">
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</div>